<script>
  export let width;
  export let height;

  $: triangleZeroPosition = 0;
  $: triangleMidPoint = width / 2;

  $: evenTrianglePath = `${triangleMidPoint}, 0 ${triangleZeroPosition}, ${height} ${width}, ${height}`;
</script>

<svg class="triangle-container even" {height} width={height}>
  <defs>
    <linearGradient
      id="example-triangle-gradient"
      x1="0%"
      y1="0%"
      x2="0%"
      y2="100%"
    >
      <stop offset="0%" style="stop-color: #4575AC; stop-opacity: 1" />
      <stop offset="100%" style="stop-color: #4B538F; stop-opacity: 1" />
    </linearGradient>
  </defs>
  <polygon
    points={evenTrianglePath}
    id="#example-triangle"
    class="triangle"
    fill="url(#example-triangle-gradient)"
  />
</svg>

<style>
  .triangle {
    stroke: white;
    stroke-width: 1px;
    stroke-width: 0.5px;
  }
</style>
